<template>
  <div class="satellite-internet-banner-area" :style="backgroundImageStyle">
    <div class="container mw-1685">
      <div
        class="satellite-internet-banner-content"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="sub">أقوى سيرفر IPTV للمشاهدة بدون تقطيع</span>
        <h1 class="text-white">نحن الخيار الأول للبث الحي والمحتوى الحصري</h1>
        <p>
          من استادات الملاعب الكبرى مباشرة إلى منزلك، عندما تبدأ المباريات الحاسمة، نضمن لك تجربة مشاهدة ثابتة ومثالية بدقة 4K و VIP.
        </p>
        <form class="check-form position-relative" @submit.prevent="window.open('https://wa.me/447429916178', '_blank')">
          <input
            type="text"
            class="form-control"
            placeholder="اكتب نوع جهازك (شاشة، هاتف، ريسيفر)..."
          />
          <button
            type="submit"
            class="btn active position-absolute top-50 end-0 translate-middle-y"
          >
            <span class="border-style">اطلب تجربة مجانية</span>
          </button>
        </form>
        <p class="already">
          هل تريد تفعيل اشتراكك الآن؟
          <a href="https://wa.me/447429916178" target="_blank">تواصل معنا مباشرة من هنا.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MainBanner",
  setup() {
    return {
      window
    };
  },
  computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: `url(${require("@/assets/images/satellite-internet/banner-bg.jpg")})`,
      };
    },
  },
});
</script>